<template>
  <img :src="img" alt="">
</template>
<script>
import Config from '@/tools/config';

export default {
  computed: {
    img() {
      return Config.get('login')
    }
  }
}

</script>